import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAuthenticityToken } from 'Shared/helpers'

import queryString from 'query-string'

import {
  selectCloneLeaguesSessions,
  selectPollSessionsStatusesURL,
  setCloneLeaguesSessionsData,
} from '../reducers/clone_leagues_sessions'
import usePolling from 'Shared/hooks/usePolling'

import { CloningStatusEnum } from '../constants'

// These statuses do not require further polling
const staticSessionStatuses = [
  CloningStatusEnum.COMPLETED,
  CloningStatusEnum.ERROR,
  CloningStatusEnum.DRAFT,
  CloningStatusEnum.TIMEOUT,
]


const POLL_INTERVAL = 5000
/* Poll for changes in the SessionsStatus */
const useSessionsStatusPolling = () => {
  const sessions = useSelector(selectCloneLeaguesSessions)
  const pollSessionsURL = useSelector(selectPollSessionsStatusesURL)
  const dispatch = useDispatch()

  const pollFn = useCallback(() => {
    const sessionIDs = sessions
      .filter(session => !staticSessionStatuses.includes(session.status))
      .map(session => session.id)

    const serializedParams = queryString.stringify({'ids': sessionIDs}, { arrayFormat: 'bracket' })
    const serializedQueryString = new URLSearchParams(serializedParams).toString()

    return fetch(`${pollSessionsURL}?${serializedQueryString}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
    }).then(response => {
      return response.json().then(data => {

        const updatedSessions = sessions.map(session => {
          const newStatus = data[session?.id?.toString()]
          return newStatus && newStatus !== session.status
            ? { ...session, status: newStatus }
            : session
        })

        dispatch(setCloneLeaguesSessionsData({ cloneLeaguesSessions: updatedSessions }))
      })
    })

  }, [ sessions, dispatch, pollSessionsURL ])

  const shouldPoll = useCallback(() => {
    return sessions.some(
      session => !staticSessionStatuses.includes(session.status),
    )
  }, [ sessions ])

  usePolling({
    pollFn,
    shouldPoll,
    interval: POLL_INTERVAL,
  })
}

export default useSessionsStatusPolling
